import { createApi } from "@reduxjs/toolkit/query/react";
import { createBaseQueryWithReauth } from "utils/baseQueryWithReauth";
import { WebsiteResponse } from "../types/types";

// Create base query with automatic token refresh
const baseWebsiteQuery = createBaseQueryWithReauth({
  baseUrl: process.env.REACT_APP_UAT_WEBSITES_API_URL || '',
});

export const websiteApiSlice = createApi({
  reducerPath: 'websitesApi',
  baseQuery: baseWebsiteQuery,
  endpoints: (builder) => ({
    getWebsite: builder.query<WebsiteResponse, { name: string }>({
      query: (data) => ({
        url: `/Websites/${encodeURIComponent(data.name)}`,
        method: 'GET',
      }),
    }),
  }),
})

export const { useGetWebsiteQuery, useLazyGetWebsiteQuery } = websiteApiSlice;

